import { OriginatorBody } from 'types';

export const isValidString = (s: string | null | undefined) =>
  s !== null && s !== undefined && s !== '';

export const isOriginatorBodyEmpty = (body?: OriginatorBody): boolean =>
  !body ||
  !(
    isValidString(body.biography) ||
    isValidString(body.history) ||
    isValidString(body.briefDescription) ||
    isValidString(body.geoObjectTypeLabel) ||
    isValidString(body.sourceInfo) ||
    isValidString(body.coordBorder) ||
    isValidString(body.coordPoint) ||
    isValidString(body.sourceInfo) ||
    isValidString(body.address) ||
    isValidString(body.corpPurpose) ||
    isValidString(body.corpStructure) ||
    isValidString(body.foundingNorms) ||
    isValidString(body.note) ||
    isValidString(body.scopeNorms) ||
    body.sourceLinks?.length > 0
  );
